export default __webpack_public_path__ + "static/media/ev-lsn-rider1.2f33c636.png";